"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
query organization {
    platformSettings {
      stripeClientId
      stripeRedirectUrl
      webFlowSiteId
    }
  }
`;
exports.default = query;
//# sourceMappingURL=platformSettings.query.js.map